/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.=
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

// Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Dashboard standardized components

// React-Select component and styling
// Dashboard example components

import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
// @mui material icons
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  getConsumedSuids,
  getDynamicColumn,
  getPoProcessLog,
  getPoProcessLogReports,
  getSubModulesByRoleId,
} from "../../../store";

// Cookies
import Cookies from "universal-cookie";

import { Backdrop } from "@mui/material";
import { addMinutes, format } from "date-fns";

import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import ViewButton from "components/standardized-components/ViewButton";
import Config from "../../../config/index";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const styleForStationModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 1100 },
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const PoProcessLog = ({
  getPoProcessLog,
  getPoProcessLogReducer,
  getSubModulesByRoleId,

  getSubModulesByRoleIdReducer,
  getPoProcessLogReports,
  getPoProcessLogReportsReducer,
  getConsumedSuids,
  getConsumedSuidsReducer,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  const subModuleId = "d629b84f-74e2-43b9-9701-9f6cb3872ba5";

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let grnModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "d629b84f-74e2-43b9-9701-9f6cb3872ba5",
  );

  let viewAccess = grnModule
    ? grnModule.actionId.includes("c4cc720a-f424-418b-a122-3535857a06af")
    : null;

  let viewConsumedSuidsAccess = grnModule
    ? grnModule.actionId.includes("345e8a8c-700b-4185-9801-4c8d2c1cd0de")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const [pageNo2, setPageNo2] = useState(0);
  const [rowsPerPage2, setRowsPerPage2] = useState(5);
  const [searchObject2, setSearchObject2] = useState(JSON.stringify({}));
  const [paginationObj2, setPaginationObj2] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);
  const [documentNo, setDocumentNo] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const importPageNo2 = (pageIndex) => {
    setPageNo2(pageIndex === -1 ? pageNo2 : pageIndex);
  };

  const importRowsPerPage2 = (pageSize) => {
    setRowsPerPage2(pageSize);
  };

  const importSearch2 = (globalFilter) => {
    setSearchObject2(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    viewAccess && getPoProcessLog(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewAccess, pageNo, rowsPerPage, searchObject]);

  useEffect(() => {
    getPoProcessLogReports(jwtToken);
  }, []);

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Pending",
      value: "Pending",
    },
    {
      label: "Started",
      value: "Started",
    },
    {
      label: "Restarted",
      value: "Restarted",
    },

    {
      label: "Paused",
      value: "Paused",
    },
    {
      label: "Completed",
      value: "Completed",
    },
  ];

  const [state, setState] = useState({
    columns: [
      {
        Header: "WO Number",
        accessor: "poNumber",
        align: "left",
      },

      {
        Header: "Work Center",
        accessor: "workCenterCode",
        align: "left",
      },
      {
        Header: "Machine Center",
        accessor: "machineCode",
        align: "left",
      },
      {
        Header: "Operation",
        accessor: "operationCode",
        align: "left",
      },
      {
        Header: "Start Time",
        accessor: "startTime",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "End Time",
        accessor: "endTime",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Time Spent",
        accessor: "actualSpentTime",
        align: "left",
      },
      {
        Header: "Hold Time",
        accessor: "restTime",
        align: "left",
      },
      {
        Header: "Status",
        accessor: "status",
        align: "left",
        searchType: "select",
        selectOptions: statusOptions,
        placeholder: "All Status",
      },
      {
        Header: "User",
        accessor: "userName",
        align: "left",
      },
      {
        Header: "action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);
  let reportsData = getPoProcessLogReportsReducer.poProcessLogReports.data
    ? getPoProcessLogReportsReducer.poProcessLogReports.data[0]
    : [];
  useEffect(() => {
    let tempGRN = [];
    let data = getPoProcessLogReducer.poProcessLog.data
      ? getPoProcessLogReducer.poProcessLog.data
      : [];

    setPaginationObj(getPoProcessLogReducer?.poProcessLog?.pagination);
    setLoading(getPoProcessLogReducer.loading);
    data.map((singleGrn) => {
      let len = desLength;
      const singleUser = {
        poNumber: singleGrn.poNumber,
        workCenterCode: singleGrn.workCenterCode,
        machineCode: singleGrn.machineCode,
        operationCode: singleGrn.operationCode,
        startTime: singleGrn.startTime,
        endTime: singleGrn?.endTime,

        actualSpentTime: singleGrn.actualSpentTime,
        restTime: singleGrn.restTime,
        status: (
          <button
            className={
              (singleGrn.status === "Pending" && `status-created`) ||
              (singleGrn.status === "Started" && `status-warning`) ||
              (singleGrn.status === "Restarted" && `status-warning`) ||
              (singleGrn.status === "Completed" && `status-success`) ||
              (singleGrn.status === "Paused" && `status-error`)
            }
            style={{ width: "6.8rem" }}
          >
            {(singleGrn.status === "Pending" && `Pending`) ||
              (singleGrn.status === "Started" && `Started`) ||
              (singleGrn.status === "Restarted" && `Restarted`) ||
              (singleGrn.status === "Completed" && `Completed`) ||
              (singleGrn.status === "Paused" && `Paused`)}
          </button>
        ),
        userName: singleGrn.userName,
        action: (
          <ViewButton
            disabled={!viewConsumedSuidsAccess}
            tooltip="View SUID"
            style={{
              marginLeft: "0.5rem",
            }}
            variant="gradient"
            color="info"
            iconOnly
            type="button"
            onClick={() => {
              setDocumentNo(singleGrn?.poNumber);
              handleOpenStationModal(singleGrn);
              getConsumedSuids(
                singleGrn?.poId,
                singleGrn?.operationId,
                pageNo2,
                rowsPerPage2,
                searchObject2,
                jwtToken,
              );
            }}
          >
            <Icon> visibility_icon </Icon>
          </ViewButton>
        ),
      };
      tempGRN.push(singleUser);
    });

    setState({ ...state, rows: tempGRN });
  }, [getPoProcessLogReducer]);

  const [stationModal, setOpenStationModal] = useState(false);
  const [documentNumber, setdocumentNumber] = useState("");

  const handleOpenStationModal = () => {
    setOpenStationModal(true);
  };
  const handleCloseStationModal = () => {
    setOpenStationModal(false);
  };

  const [stationTable, setStationTable] = useState({
    columns: [
      { Header: "Item Code", accessor: "itemCode" },

      { Header: "booked Suid", accessor: "bookedSuid" },

      { Header: "booked Qty", accessor: "bookedQty" },

      {
        Header: "booked Date",

        accessor: "bookedDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      { Header: "consumed Suid", accessor: "consumedSuid" },
      { Header: "consumed Qty", accessor: "consumedQty" },
      {
        Header: "consumed Date",

        accessor: "consumedDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });

  const [loading2, setLoading2] = useState(true);

  const { columns: stationColumns, rows: stationRows } = stationTable;

  useEffect(() => {
    let tempStations = [];
    let data = getConsumedSuidsReducer.consumedSuids.data
      ? getConsumedSuidsReducer.consumedSuids.data
      : [];
    setLoading2(getConsumedSuidsReducer.loading);
    setPaginationObj2(getConsumedSuidsReducer?.consumedSuids?.pagination);
    data &&
      data.map((station) => {
        let des = station?.itemDescription;
        let len = desLength;
        const stationObj = {
          sku: station.suid,
          bookedSuid: station.bookedSuid,
          itemCode: station.itemCode,
          itemDescription: `${des ? des.substring(0, len) : ""}`,
          rejectedLocation: station.rejectedLocation,
          consumedDate: station.consumedDate,
          bookedQty: `${station.bookedQty}`,
          consumedQty: `${station.consumedQty}`,

          bookedDate: station.bookedDate,
          consumedSuid: station.consumedSuid,
        };
        tempStations.push(stationObj);
      });

    // viewStations &&
    setStationTable({ ...stationTable, rows: tempStations });
  }, [getConsumedSuidsReducer]);

  const stats = [
    {
      label: "Total",
      value: reportsData?.totalOperations,
      icon: <ListAltIcon />,
      color: "#1976d2",
    },
    {
      label: "Completed",
      value: reportsData?.completed,
      icon: <CheckCircleIcon />,
      color: "#2e7d32",
    },
    {
      label: "In Progress",
      value: reportsData?.inProgress,
      icon: <HourglassTopIcon />,
      color: "#f9a825",
    },
    {
      label: "On Hold",
      value: reportsData?.onHold,
      icon: <PauseCircleIcon />,
      color: "#d32f2f",
    },
    {
      label: "Total Time",
      value: reportsData?.totalTime,
      icon: <AccessTimeIcon />,
      color: "#6a1b9a",
    },
    // {
    //   label: "Hold Time",
    //   value: "2h 30m",
    //   icon: <TimerOffIcon />,
    //   color: "#c2185b",
    // },
  ];

  const StatCard = ({ label, value, icon, color }) => (
    <Card
      sx={{
        minWidth: 150,
        textAlign: "center",
        boxShadow: 3,
        borderLeft: `6px solid ${color}`,
        cursor: "pointer",
        transition: "transform 0.2s",
        "&:hover": {
          transform: "scale(1.03)",
        },
        height: "90px",
      }}
      // onClick={() => alert(`${label} clicked!`)}
    >
      <CardContent>
        <MDBox display="flex" justifyContent="center" mb={1}>
          <Icon sx={{ color }}>{icon}</Icon>
        </MDBox>
        <MDTypography variant="subtitle2" color="text.secondary">
          {label}
        </MDTypography>
        <MDTypography variant="h6" fontWeight="bold">
          {value}
        </MDTypography>
      </CardContent>
    </Card>
  );

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getPoProcessLog(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <>
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* {downloadNewGRN ? (
              <CSVLink {...csvLink}>
                <Tooltip title="Download Printed GRN">
                  <MDButton
                    style={{ marginRight: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="success"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </MDButton>
                </Tooltip>
              </CSVLink>
            ) : (
              ""
            )} */}

            <Grid container spacing={2} justifyContent="left">
              {stats?.map((stat, index) => (
                <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
                  <StatCard {...stat} />
                </Grid>
              ))}
            </Grid>

            <MDBox pt={3}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  options={{ draggable: false }}
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDBox>
            <Modal
              open={stationModal}
              onClose={handleCloseStationModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForStationModal}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    WO Number:{documentNo}
                  </MDTypography>

                  <MDBox display="flex" marginLeft="auto">
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            display: "flex",
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "auto",
                            marginBottom: "5px",
                            marginRight: "10px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseStationModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginBottom: "1rem" }} />
                <MDBox>
                  {!loading2 ? (
                    <DataTable
                      table={{ columns: stationColumns, rows: stationRows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                      serverSidePagination={true}
                      paginationObj={paginationObj2}
                      pageNoValue={pageNo2}
                      rowsPerPageValue={rowsPerPage2}
                      pageNoProp={importPageNo2}
                      rowsPerPageProp={importRowsPerPage2}
                      searchProp={importSearch2}
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "100px",
                        marginBottom: "100px",
                      }}
                    >
                      <CircularProgress color="info" />
                    </div>
                  )}
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,

    getPoProcessLogReducer: state.getPoProcessLogReducer,
    getPoProcessLogReportsReducer: state.getPoProcessLogReportsReducer,
    getConsumedSuidsReducer: state.getConsumedSuidsReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getPoProcessLog: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getPoProcessLog(pageNo, rowsPerPage, searchObject, jwtToken)),
    getPoProcessLogReports: (jwtToken) =>
      dispatch(getPoProcessLogReports(jwtToken)),
    getConsumedSuids: (
      poId,
      operationId,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getConsumedSuids(
          poId,
          operationId,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(PoProcessLog);
